// @ts-nocheck
import React, { useState, useEffect } from "react";
import style from "./ChangePlan.module.scss";
import axios from "axios";
axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";
import { InfoBtn } from "../../common/Payment/InfoBtn";
import { PageLoader } from "../../common/Loaders/PageLoader";
import { SecondaryBtn } from "../../common/Payment/SecondaryBtn";
import { Stripe } from "../../common/Payment/DashBoardStripe";
import { InfoCard } from "../../common/Payment/InfoCard";
import { ChangePlanPriceList } from "./ChangePlanPriceList";
import { ChangeTrialModalBody } from "./ChangeTrialModalBody";
import { ChangeFreePlanModalBody } from "./ChangeFreePlanModalBody";
import { ChangePaidPlanModalBody } from "./ChangePaidPlanModalBody";
import { getImageUrl } from "../../../commons/assets_path";
import { useTranslation } from "react-i18next";
import { prefectures } from "../../../hooks/prefectures";

import type { NoticeType } from "../../../types/settingsTypes";

type Props = {
  client: string;
  client_id: number;
  plans: object;
  plan_prices: object;
  available_trial_plans: [];
  past_trial_plans: [];
  current_trial_plan: string;
  setNotice: (notice: NoticeType) => void;
  handleModalShow: (setShow: (show: boolean) => void, width: string, height: string) => void;
  handleModalClose: (setShow: (show: boolean) => void) => void;
  changeModalCss: (width: string, height: string) => void;
  cardStatus: string;
};

const ChangePlan = ({
  client,
  plans,
  plan_prices,
  client_id,
  available_trial_plans,
  past_trial_plans,
  current_trial_plan,
  setNotice,
  handleModalShow,
  handleModalClose,
  changeModalCss,
  cardStatus,
}: Props) => {
  const { t } = useTranslation();
  const [currentPlan, setCurrentPlan] = useState();
  const [inProgress, setInProgress] = useState(true);
  const [show, setShow] = useState(false);
  const [trialShow, setTrialShow] = useState(false);
  const [errMessage, setErrMessage] = useState("");
  const [updatePlanErrMessage, setUpdatePlanErrMessage] = useState([]);
  const [beforeUpdatePlanErrMessage, setBeforeUpdatePlanErrMessage] = useState([]);
  // 現在の契約期間を固定で保持するためのstate
  const [currentPaymentPeriod, setCurrentPaymentPeriod] = useState("year");

  const [selectPaymentPeriod, setSelectPaymentPeriod] = useState("year");
  const [currentPageNumber, setCurrentPageNumber] = useState(0);
  const [id, setId] = useState("");
  const [card, setCard] = useState("");
  const [isUpdate, setIsUpdate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isBeforeUpdatePlanLoading, setIsBeforeUpdatePlanLoading] = useState(false);

  const [paymentOption, setPaymentOption] = useState("credit_card");
  const [afterPlanName, setAfterPlanName] = useState("");
  const [afterPlanCode, setAfterPlanCode] = useState("");
  const [downGradeFlag, setDownGradeFlag] = useState(false);
  const [afterPlanInfo, setAfterPlanInfo] = useState({});
  const [planDowngradeInfo, setPlanDowngradeInfo] = useState({});
  const [trialPlanName, setTrialPlanName] = useState("");
  const [trialPlanCode, setTrialPlanCode] = useState("");
  const [isUpdating, setIsUpdating] = useState(false);
  const [isUpdateTrial, setIsUpdateTrial] = useState(false);
  const [isUpdatePlan, setIsUpdatePlan] = useState(false);

  const handleClose = () => {
    setCurrentPageNumber(0);
    setUpdatePlanErrMessage([]);
    setBeforeUpdatePlanErrMessage([]);
    setAfterPlanInfo({});
    handleModalClose(setShow);
    setShow(false);
  };
  const handleShow = () => {
    handleModalShow(setShow, "650px", "auto");
  };
  const handleTrialShow = () => {
    handleModalShow(setTrialShow, "480px", "548px");
  };
  const handleTrialClose = () => {
    handleModalClose(setTrialShow);
  };

  const getCurrentPlan = async () => {
    await axios
      .get(`/${client}/settings/client_plan_log/current_period_plan`)
      .then((res) => {
        setCurrentPlan(res.data);
        setCurrentPaymentPeriod(
          res.data.interval === t("ChangePlan.年間契約")
            ? "year"
            : res.data.interval === t("ChangePlan.半年契約")
            ? "half_year"
            : "month",
        );
      })
      .catch((_) => {
        return;
      });
  };

  const registerCard = async (token) => {
    setIsLoading(true);
    await axios
      .post(`/${client}/api_cards`, {
        token_id: token,
        default: true,
      })
      .then((res) => {
        // 登録したクレジットカードで決済テストを実行して３Dスキャンを実施する
        requestThreeDSecure(res.data.stripe_card_id, res.data.stripe_customer_id);
      })
      .catch((_) => {
        setIsLoading(false);
        setErrMessage(t("ChangePlan.クレジットカードの登録に失敗しました。"));
        return;
      });
  };

  const updateCard = async (token) => {
    setIsLoading(true);
    await axios
      .post(`/${client}/api_cards`, {
        token_id: token,
        default: false,
      })
      .then((res) => {
        // 登録したクレジットカードで決済テストを実行して３Dスキャンを実施する
        requestThreeDSecure(res.data.stripe_card_id, res.data.stripe_customer_id);
      })
      .catch((_) => {
        setIsLoading(false);
        setErrMessage(t("ChangePlan.クレジットカードの更新に失敗しました。"));
        return;
      });
  };

  const requestThreeDSecure = async (stripe_card_id, stripe_customer_id) => {
    let period = selectPaymentPeriod;
    if (afterPlanCode === "success" && selectPaymentPeriod === "month") {
      period = "half_year";
    }

    await axios
      .post(`/${client}/api_cards/request_three_d_secure`, {
        current_url: window.location.href,
        stripe_card_id: stripe_card_id,
        stripe_customer_id: stripe_customer_id,
        payment_method: paymentOption,
        code: afterPlanCode,
        period_type: period,
      })
      .then((res) => {
        if (res.data.redirect_to_url !== "") {
          // 3Dスキャンの実行ページを表示する。
          window.location.href = res.data.redirect_to_url;
        }
        setErrMessage("");
        setIsLoading(false);
        getCard();
      })
      .catch((_) => {
        setPaymanetMethodErrMessage(t("ChangePlan.request_three_d_secure_result.failed_plan_update"));
        setIsLoading(false);
        return;
      });
  };

  const changeCard = () => {
    setIsUpdate(true);
  };

  const getCard = async () => {
    await axios
      .get(`/${client}/api_cards/default_card`, {
        params: {
          default_only: true,
        },
      })
      .then((res) => {
        if (!res.data.id) {
          return;
        } else {
          setId(res.data.id);
          setCard(res.data);
          setErrMessage("");
        }
      })
      .catch((_) => {
        return;
      });
  };

  const initConnect = async () => {
    await getCurrentPlan();
    await getCard();
    await fetchPlanDowngradeInfo();
    await setInProgress(false);
  };

  const updatePlan = async (isViaPartner = false) => {
    if (isUpdating) return;

    setIsUpdating(true);
    setIsLoading(true);
    let params = {};
    if (afterPlanCode === "free") {
      params = {
        code: afterPlanCode,
        period_type: "month",
        payment_method: currentPlan.payment_method,
      };
    } else if (afterPlanCode === "success" && selectPaymentPeriod === "month") {
      params = {
        code: afterPlanCode,
        period_type: "half_year",
        payment_method: isViaPartner ? "send_invoice" : paymentOption,
      };
    } else {
      params = {
        code: afterPlanCode,
        period_type: selectPaymentPeriod,
        payment_method: isViaPartner ? "send_invoice" : paymentOption,
      };
    }

    await axios
      .patch(`/clients/${client_id}/update_plan`, params)
      .then((res) => {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set("category", "plan-and-billing");
        window.location.href = currentUrl;
      })
      .catch(({ response }) => {
        setUpdatePlanErrMessage(Object.values(response.data));
        setIsLoading(false);
        setIsUpdating(false);
        return;
      });
  };

  const changePlanCheck = async (selectAfterPlanCode) => {
    setIsBeforeUpdatePlanLoading(true);
    if (currentPlan.plan_name === t("ChangePlan.フリー")) {
      applyChangePlan(selectAfterPlanCode);
    } else {
      await axios
        .get(`/clients/${client_id}/validate_update_plan`, {
          params: {
            code: selectAfterPlanCode,
          },
        })
        .then((res) => {
          if (Object.keys(res.data).length) {
            setBeforeUpdatePlanErrMessage(Object.values(res.data));
            setIsBeforeUpdatePlanLoading(false);
          } else {
            applyChangePlan(selectAfterPlanCode);
          }
        })
        .catch((_) => {
          setIsBeforeUpdatePlanLoading(false);
          return;
        });
    }
  };

  const applyChangePlan = async (selectAfterPlanCode) => {
    const after_period_type =
      selectAfterPlanCode === "success" && selectPaymentPeriod === "month"
        ? "half_year"
        : selectAfterPlanCode === "free"
        ? "month"
        : selectPaymentPeriod;

    await axios
      .get(
        `/${client}/settings/client_plan_log/apply_change_plan?after_plan_code=${selectAfterPlanCode}&after_period_type=${after_period_type}&currency=jpy`,
      )
      .then((res) => {
        setAfterPlanInfo(res.data);
        setIsBeforeUpdatePlanLoading(false);
      })
      .catch((_) => {
        setIsBeforeUpdatePlanLoading(false);
        return;
      });
  };

  const upOrDownCheck = (currentPlan, afterPlan, currentPeriod, afterPeriod) => {
    if (
      (currentPeriod === "year" && afterPeriod === "half_year") ||
      (currentPeriod === "year" && afterPeriod === "month") ||
      (currentPeriod === "half_year" && afterPeriod === "month") ||
      (currentPlan === t("ChangePlan.サクセス") && afterPlan === t("ChangePlan.チーム")) ||
      (currentPlan === t("ChangePlan.サクセス") && afterPlan === t("ChangePlan.ミニ")) ||
      (currentPlan === t("ChangePlan.チーム") && afterPlan === t("ChangePlan.ミニ"))
    ) {
      setDownGradeFlag(true);
    } else {
      setDownGradeFlag(false);
    }
  };

  const fetchPlanDowngradeInfo = async () => {
    await axios
      .get(`/${client}/settings/client_plan_log/scheduled_downgrade`)
      .then((res) => {
        setPlanDowngradeInfo(res.data);
      })
      .catch((_) => {
        return;
      });
  };

  const handlePlanDowngradeRedirect = (e: React.MouseEvent) => {
    e.preventDefault();
    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set("category", "plan-and-billing");
    window.location.href = currentUrl;
  };

  useEffect(() => {
    initConnect();
  }, []);

  return (
    <div className={style.wrap}>
      {!inProgress ? (
        <>
          {trialShow ? (
            <div style={{ width: "100%" }}>
              <ChangeTrialModalBody
                client={client}
                trialPlanName={trialPlanName}
                trialPlanCode={trialPlanCode}
                isLoading={isLoading}
                handleTrialClose={handleTrialClose}
                setNotice={setNotice}
                is_internal={true}
              />
            </div>
          ) : show ? (
            <div style={{ width: "100%" }}>
              {currentPageNumber === 0 ? (
                <div style={{ width: "100%" }}>
                  {Object.keys(planDowngradeInfo).length ? (
                    <div className={style.changePlanModalWrap}>
                      <div className={style.changePlanModalTitle}>{t("ChangePlan.プラン変更申し込み（1/2）")}</div>
                      <div className={style.beforeUpdatePlanErr}>
                        <div>
                          {t("ChangePlan.プランの変更が予約されているため、新たに変更することができません。")}
                          <br />
                          <a href="#" onClick={handlePlanDowngradeRedirect}>
                            {t("ChangePlan.こちら")}
                          </a>
                          {t("ChangePlan.から現在のプラン変更予約の取り消しを行った上で、実施してください。")}
                        </div>
                      </div>
                    </div>
                  ) : (
                    <>
                      {isBeforeUpdatePlanLoading ? (
                        <div style={{ marginTop: "50px" }}>
                          <PageLoader />
                        </div>
                      ) : (
                        <>
                          {beforeUpdatePlanErrMessage.length ? (
                            <div className={style.changePlanModalWrap}>
                              <div className={style.changePlanModalTitle}>
                                {t("ChangePlan.プラン変更申し込み（1/2）")}
                              </div>
                              <div className={style.beforeUpdatePlanErr}>
                                {beforeUpdatePlanErrMessage.map((errMessage, i) => (
                                  <div key={i} className="d-flex">
                                    <span>・</span>
                                    <span>{errMessage}</span>
                                  </div>
                                ))}
                              </div>
                            </div>
                          ) : (
                            <>
                              {afterPlanName === t("ChangePlan.フリー") ? (
                                <ChangeFreePlanModalBody
                                  afterPlanInfo={afterPlanInfo}
                                  updatePlanErrMessage={updatePlanErrMessage}
                                  isLoading={isLoading}
                                  handleClose={handleClose}
                                  updatePlan={updatePlan}
                                />
                              ) : (
                                <ChangePaidPlanModalBody
                                  currentPlan={currentPlan}
                                  currentPaymentPeriod={currentPaymentPeriod}
                                  afterPlanName={afterPlanName}
                                  afterPlanInfo={afterPlanInfo}
                                  selectPaymentPeriod={selectPaymentPeriod}
                                  downGradeFlag={downGradeFlag}
                                  isLoading={isLoading}
                                  handleClose={handleClose}
                                  updatePlan={updatePlan}
                                  setCurrentPageNumber={setCurrentPageNumber}
                                  changeModalCss={changeModalCss}
                                />
                              )}
                            </>
                          )}
                        </>
                      )}
                    </>
                  )}
                </div>
              ) : (
                <div className={style.changePlanPaymentMethodWrap}>
                  <div className={style.changePlanPaymentMethodTitle}>{t("ChangePlan.プラン変更申し込み（2/2）")}</div>
                  <div className={style.changePlanPaymentMethodContent}>
                    <div className={style.changePlanModalDescriptionBold}>
                      {t("ChangePlan.まだプラン変更は完了していません。")}
                    </div>
                    <div>{t("ChangePlan.支払い方法を選んで、申し込むをクリックしてください。")}</div>
                  </div>

                  <div className="mb-4">
                    {errMessage && (
                      <div className={style.error}>
                        {errMessage}
                        <div onClick={() => setErrMessage(null)} style={{ cursor: "pointer", marginLeft: "10px" }}>
                          <img
                            src={getImageUrl("images/icons/cancel_error.svg")}
                            style={{ width: "20px", height: "20px" }}
                          />
                        </div>
                      </div>
                    )}
                    <div style={{ padding: "16px", marginTop: "24px" }}>
                      <div className="d-flex justify-content-between align-items-center">
                        <div
                          style={{ color: "#222222", fontSize: "16px", fontFamily: "Noto Sans JP", fontWeight: "700" }}
                        >
                          {t("ChangePlan.支払い情報")}
                        </div>
                        <select
                          value={paymentOption}
                          style={{ textAlign: "right", height: "20px", border: "none", outline: "none" }}
                          onChange={(e) => setPaymentOption(e.target.value)}
                        >
                          <option value="credit_card">{t("ChangePlan.クレジットカード払い")}</option>
                          <option value="send_invoice">{t("ChangePlan.請求書払い")}</option>
                        </select>
                      </div>
                      {paymentOption === "credit_card" && (
                        <>
                          {!id || (id && isUpdate) ? (
                            <div>
                              <div className="d-flex flex-column" style={{ margin: "5px 0px 15px" }}>
                                <Stripe
                                  client={client}
                                  isUpdate={isUpdate}
                                  register={(token) => registerCard(token)}
                                  update={(token) => updateCard(token)}
                                  setIsUpdate={() => setIsUpdate(false)}
                                  updateAmountPlan={updatePlan}
                                  setIsLoading={setIsLoading}
                                />
                              </div>
                            </div>
                          ) : (
                            <InfoCard
                              card={card}
                              changeFunc={() => changeCard()}
                              styles={{ marginTop: "16px", height: "50px" }}
                            />
                          )}
                        </>
                      )}
                    </div>
                    <>
                      {updatePlanErrMessage.length ? (
                        <div className={style.updatePlanErr}>
                          {updatePlanErrMessage.map((errMessage, i) => (
                            <div key={i}>{errMessage}</div>
                          ))}
                        </div>
                      ) : (
                        <></>
                      )}
                    </>
                  </div>
                  <div className={style.changePlanPaymentMethodButtonWrap}>
                    <SecondaryBtn
                      text={t("ChangePlan.戻る")}
                      disabled={false}
                      className={`test-force-upgrade ${style.changePlanPaymentMethodButton}`}
                      submit={() => {
                        setCurrentPageNumber(0);
                        changeModalCss("650px", "auto");
                      }}
                      style={{ color: "#222222" }}
                    />
                    <InfoBtn
                      text={t("ChangePlan.申し込む")}
                      loading={isLoading}
                      className={`test-force-upgrade ${style.changePlanPaymentMethodButton}`}
                      submit={() => {
                        (!id && paymentOption === "credit_card") || (id && isUpdate && paymentOption === "credit_card")
                          ? ""
                          : updatePlan();
                      }}
                      stripeFlag={
                        (!id && paymentOption === "credit_card") || (id && isUpdate && paymentOption === "credit_card")
                          ? true
                          : false
                      }
                    />
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div className={style.content} data-testid="test-change-plan-content">
              {errMessage && (
                <div className={style.error}>
                  {errMessage}
                  <div onClick={() => setErrMessage(null)} style={{ cursor: "pointer", marginLeft: "10px" }}>
                    <img src={getImageUrl("images/icons/cancel_error.svg")} style={{ width: "20px", height: "20px" }} />
                  </div>
                </div>
              )}
              <ChangePlanPriceList
                availableTrialPlans={available_trial_plans}
                currentTrialPlan={current_trial_plan}
                pastTrialPlans={past_trial_plans}
                plans={plans}
                plan_prices={plan_prices}
                currentPlan={currentPlan}
                currentPaymentPeriod={currentPaymentPeriod}
                selectPaymentPeriod={selectPaymentPeriod}
                setSelectPaymentPeriod={setSelectPaymentPeriod}
                setAfterPlanName={setAfterPlanName}
                setAfterPlanCode={setAfterPlanCode}
                setTrialPlanName={setTrialPlanName}
                setTrialPlanCode={setTrialPlanCode}
                handleShow={handleShow}
                handleTrialShow={handleTrialShow}
                changePlanCheck={changePlanCheck}
                upOrDownCheck={upOrDownCheck}
              />
            </div>
          )}
        </>
      ) : (
        <PageLoader loadingHeight={"360px"} />
      )}
    </div>
  );
};

export default ChangePlan;
